import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/cbs";

const GET_TODO_LIST = `
	todolists (limit: $limit,
		page: $page,
		search: $search,
		listOrderBy: $listOrderBy,
		category_id: $category_id,
		type: $type,
		flag: $flag,
		from_start_date: $from_start_date,
		to_start_date: $to_start_date,
		from_deadline: $from_deadline,
		to_deadline: $to_deadline,
		assignees: $assignees,
		relations: $relations,
		statuses: $statuses,
		priority: $priority,
		is_child: $is_child,
		creator_employee_id: $creator_employee_id,
		parent_id: $parent_id,
		department_ids: $department_ids) {
		data {
			...TodoItemBasicPagination
		}
		total
		per_page
	}
`;

const ADD_TODO_ITEM = `
	create_todolist (
		name: $name,
		assignees: $assignees,
		description: $description,
		start_date: $start_date,
		relations: $relations,
		priority: $priority,
		watchers: $watchers,
		due_value: $due_value,
		due_unit: $due_unit,
		schedule_repeat: $schedule_repeat
		check_list: $check_list
		schedule_enable: $schedule_enable
		attachs: $attachs,
		type: $type,
		category_id: $category_id,
		forms: $forms,
		due_mode: $due_mode,
		deadline: $deadline,
		parent_id: $parent_id,
		project_id: $project_id,
		is_children_sequence: $is_children_sequence

	) {
    	...TodoItemWithOutCommentsPagination
	}
`;

const UPDATE_TODO_ITEM = `
	update_todolist (
		id: $id,
		name: $name,
		assignees: $assignees,
		description: $description,
		start_date: $start_date,
		priority: $priority,
		watchers: $watchers,
		due_value: $due_value,
		due_unit: $due_unit,
		schedule_repeat: $schedule_repeat,
		schedule_enable: $schedule_enable,
		relations: $relations,
		attachs: $attachs,
		type: $type,
		forms: $forms,
		due_mode: $due_mode,
		deadline: $deadline,
		is_children_sequence: $is_children_sequence,
		project_id: $project_id,

	) {
    	...TodoItemWithOutCommentsPagination
	}
`;

const GET_TODO_ITEM = `
	todolist (id: $id) {
		...TodoItemDetail
	}
`;

const COMPLETE_TODO_ITEM = `
	done_todolist (
		id: $id
	) {
    	...TodoItemWithOutCommentsPagination
	}
`;

const RATING_TODO_ITEM = `
	rating_todolist (
		id: $id,
		review: $review,
	) {
    	...TodoItemWithOutCommentsPagination
	}
`;

const ADD_CHECK_LIST_ITEM = `
	create_todoitem(title: $title,  todolist_id: $todolist_id) {
		id
		title
		done_at
	}`;
const UPDATE_CHECK_LIST_ITEM = `
	update_todoitem(id: $id, title: $title) {
		id
		title
	}`;

const DELETE_CHECK_LIST_ITEM = `
	delete_todoitem(id: $id) {
		id
	}`;

const DONE_CHECK_LIST_ITEM = `
	done_todoitem(id: $id, is_done: $isDone) {
		id
		title
		done_at
		done_by
	}`;

const GET_TODO_LIST_LOGS = `
	logs(limit: $limit, page: $page, relation_id: $relation_id, relation_type: $relation_type) {
		has_more_pages
		total
		per_page
		data {
			id
			event
			content
			created_at
			user {
				first_name
			}
		}
	}`;

const GET_TODO_LISTS_TODAY = `
	todolists (limit: $limit, page: $page, type: $type, orderBy: $orderBy,
		from_start_date: $from_start_date,
		to_start_date: $to_start_date ,
		from_deadline: $from_deadline,
		to_deadline: $to_deadline ) {
		data {
			...TodoItemWithOutCommentsPagination
		}
		total
		per_page
	}
`;

const CANCEL_TODO_ITEM = `
	cancel_todolist (id: $id, cancel_reason: $cancel_reason) {
		...TodoItemWithOutCommentsPagination
	}
`;

const REJECT_TODO_ITEM = `
	reject_todolist (id: $id, reject_reason: $reject_reason) {
		...TodoItemWithOutCommentsPagination
	}
`;
const SET_STATUS_TODOLIST = `
	set_status_todolist(id: $id, status: $status, info: $info) {
		...TodoItemDetail
	}
`;
const TOGGLE_SCHEDULE_TODOLIST = `
	toggle_schedule_todolist(id: $id, enable: $enable) {
		...TodoItemDetail
	}`;

const GET_TODO_LIST_BY_RELATIONS = `
	todolists (limit: $limit,
		page: $page,
		orderBy: $orderBy,
		type: $type,
		statuses: $statuses,
		relations: $relations) {
		data {
			...TodoItemLogsByRelations
		}
		total
		per_page
	}
`;

const GET_TODO_LIST_STATISTIC = `
	todolist_statistic {
		...TodoStatistic
	}
`;
const UPDATE_TODO_ITEM_WATCHER = `update_todolist (
	id: $id,
	watchers: $watchers,
	name: $name
	) {
		...TodoItemDetail
	}
`;

const UPDATE_MULTIPLE_TODO_ITEM = `
	update_multiple_todolist (list: $list) {
    	...TodoItemWithOutCommentsPagination
	}
`;

const GET_TODO_LIST_COUNT = `
	todolist_count (flag: $flag)  {
		id
		name
		display
		content
  	}
`;

const CLONE_TODOLIST = `
	clone_todolist(id:$id) {
		...TodoItemBasicPagination
	}`;
const UPDATE_TODO_ITEM_ATTACHS = `
	update_attachs_todolist(id: $id,attachs: $attachs) {
		...TodoItemDetailAttachs
	}
`;

export default {
	init() {},

	fetchTodoList(payload) {
		const queryOptions = {
			query: gql`query ListTodoList (
				$limit: Int!,
				$page: Int!,
				$search: String,
				$category_id: Int ,
				$type: Int,
				$flag: Int,
				$from_start_date: String,
				$to_start_date: String,
				$from_deadline: String,
				$to_deadline: String,
				$assignees: [IdTypeInput],
				$relations: [IdTypeInput],
				$statuses: [Int],
				$priority: Int,
				$is_child: Boolean,
				$creator_employee_id: Int,
				$parent_id: Int,
				$listOrderBy: [OrderByObject],
				$department_ids: [Int] ) {
					${GET_TODO_LIST}
				}
				${fragments.TodoItemBasicPagination}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				search: payload.search || "",
				listOrderBy: payload.listOrderBy || [],
				category_id: payload.category_id || 0,
				type: payload.type,
				flag: payload.flag,
				from_start_date: payload.from_start_date || null,
				to_start_date: payload.to_start_date || null,
				from_deadline: payload.from_deadline || null,
				to_deadline: payload.to_deadline || null,
				statuses: payload.statuses || [],
				assignees: payload.assignees || [],
				relations: payload.relations || [],
				priority: payload.priority,
				is_child: payload.is_child,
				creator_employee_id: payload.creator_employee_id || null,
				parent_id: payload.parent_id || null,
				department_ids: payload.department_ids || []
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				todoList: response.data.todolists.data,
				totalTodoList: response.data.todolists.total
			};
		});
	},

	addTodoItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementCreateTodoItem (
					$name: String!,
					$assignees: [IdTypeInput],
					$description: String,
					$start_date: DateTime,
					$priority: Int,
					$watchers: [TodolistWatcherInput],
					$due_value: Int ,
					$due_unit: String ,
					$schedule_repeat: TodolistRepeatInput,
					$relations: [IdTypeInput],
					$check_list : [String],
					$schedule_enable: Boolean,
					$attachs: [Int],
					$type: Int,
					$category_id: Int,
					$forms: [Int],
					$due_mode: Int,
					$deadline: DateTime,
					$parent_id: Int,
					$project_id: Int,
					$is_children_sequence: Boolean
					) {
						${ADD_TODO_ITEM}
					}
					${fragments.TodoItemWithOutCommentsPagination}

				`,
				variables: {
					name: payload.name,
					forms: payload.forms || [],
					assignees: payload.assignees || null,
					description: payload.description || "",
					start_date: payload.start_date,
					priority: payload.priority,
					watchers: payload.watchers || [],
					due_value: payload.due_value,
					due_unit: payload.due_unit || "",
					schedule_repeat: payload.schedule_repeat || { freq: "", interval: 0 },
					check_list: payload.check_list || [],
					schedule_enable: payload.schedule_enable || false,
					attachs: payload.attachs || [],
					type: payload.type || 0,
					relations: payload.relations || [],
					category_id: payload.category_id || 0,
					due_mode: payload.due_mode,
					deadline: payload.deadline,
					parent_id: payload.parent_id || null,
					project_id: payload.project_id || null,
					is_children_sequence: payload.is_children_sequence || false
				}
			})
			.then(response => response.data.create_todolist);
	},

	updateTodoItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementUpdateTodoItem (
					$id: Int!,
					$name: String!,
					$assignees: [IdTypeInput],
					$description: String,
					$start_date: DateTime,
					$project_id: Int,
					$priority: Int,
					$watchers: [TodolistWatcherInput],
					$due_value: Int,
					$due_unit: String,
					$schedule_repeat: TodolistRepeatInput,
					$schedule_enable: Boolean,
					$relations: [IdTypeInput],
					$attachs: [Int],
					$type: Int,
					$forms: [Int],
					$due_mode: Int,
					$deadline: DateTime,
					$is_children_sequence: Boolean
					) {
						${UPDATE_TODO_ITEM}
					}
					${fragments.TodoItemWithOutCommentsPagination}

				`,
				variables: {
					id: payload.id,
					name: payload.name,
					forms: payload.forms || [],
					assignees: payload.assignees || null,
					description: payload.description || "",
					start_date: payload.start_date || null,
					priority: payload.priority,
					watchers: payload.watchers || [],
					due_value: payload.due_value || null,
					due_unit: payload.due_unit || "",
					schedule_repeat: payload.schedule_repeat || { freq: "", interval: 0 },
					schedule_enable: payload.schedule_enable || false,
					attachs: payload.attachs || [],
					type: payload.type || 0,
					relations: payload.relations || [],
					due_mode: payload.due_mode,
					deadline: payload.deadline,
					project_id: payload.project_id || null,
					is_children_sequence: payload.is_children_sequence || false
				}
			})
			.then(response => response.data.update_todolist);
	},

	getTodoItem(id, commentsPagination = {}) {
		const queryOptions = {
			query: gql`query TodoListManagementDetailWithComment ($id: Int!) {
					${GET_TODO_ITEM}
				}
				${fragments.TodoItemDetail}
			`,
			variables: {
				id,
				commentsPage: commentsPagination.page || 1,
				commentsLimit: commentsPagination.limit || 5
			}
		};

		return graphqlClient.query(queryOptions).then(response => response.data.todolist);
	},

	completeTodoItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementCompleteTodoItem (
					$id: Int!
				) {
					${COMPLETE_TODO_ITEM}
				}
				${fragments.TodoItemWithOutCommentsPagination}
			`,
				variables: {
					id: payload.id
				}
			})
			.then(response => response.data.done_todolist);
	},

	ratingTodoItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementRatingTodoItem (
					$id: Int!,
					$review: Int
				) {
					${RATING_TODO_ITEM}
				}
				${fragments.TodoItemWithOutCommentsPagination}
			`,
				variables: {
					id: payload.id,
					review: payload.review || 0
				}
			})
			.then(response => response.data.rating_todolist);
	},

	addCheckListItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementCreateCheckListItem (
					$title: String!,
					$todolist_id: Int!
					) {
						${ADD_CHECK_LIST_ITEM}
					}
					`,
				variables: {
					title: payload.title,
					todolist_id: payload.todolist_id
				}
			})
			.then(response => {
				return response.data.create_todoitem;
			});
	},

	updateCheckListItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementUpdateCheckListItem (
					$id: Int!,
					$title: String!
					) {
						${UPDATE_CHECK_LIST_ITEM}
					}
					`,
				variables: {
					title: payload.title,
					id: payload.id
				}
			})
			.then(response => {
				return response.data.update_todoitem;
			});
	},

	deleteCheckListItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementDeleteCheckListItem (
					$id: Int!
					) {
						${DELETE_CHECK_LIST_ITEM}
					}
					`,
				variables: {
					id: payload.id
				}
			})
			.then(response => {
				return response.data.delete_todoitem;
			});
	},

	checkDoneCheckListItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementDoneCheckListItem (
					$id: Int!,
					$isDone: Boolean!
					) {
						${DONE_CHECK_LIST_ITEM}
					}
					`,
				variables: {
					id: payload.id,
					isDone: payload.isDone
				}
			})
			.then(response => {
				return response.data.done_todoitem;
			});
	},

	fetchTodoLogs(payload) {
		const queryOptions = {
			query: gql`query ListTodoListLogs ($limit: Int!, $page: Int!, $relation_id: Int!, $relation_type: String!) {
				${GET_TODO_LIST_LOGS}
			}`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				relation_id: payload.relation_id || null,
				relation_type: payload.relation_type || "Comay\\Cmagile\\Models\\Todolist"
			}
		};

		return graphqlClient.query(queryOptions).then(response => {
			return {
				logs: response.data.logs.data
			};
		});
	},

	fetchTodoOfToday(payload) {
		const queryOptions = {
			query: gql`query ListTodoListToday (
				$limit: Int!,
				$page: Int!,
				$type: Int,
				$orderBy: OrderByObject,
				$from_start_date: String,
				$to_start_date: String,
				$from_deadline: String,
				$to_deadline: String) {
				${GET_TODO_LISTS_TODAY}
			}
			${fragments.TodoItemWithOutCommentsPagination}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				type: payload.type || 0,
				orderBy: payload.orderBy || { column: "id", direction: "desc" },
				from_start_date: payload.from_start_date || null,
				to_start_date: payload.to_start_date || null,
				from_deadline: payload.from_deadline || null,
				to_deadline: payload.to_deadline || null
			}
		};

		return graphqlClient.query(queryOptions).then(response => {
			return {
				todoListToday: response.data.todolists.data,
				totalTodoListToday: response.data.todolists.total
			};
		});
	},
	cancelTodoItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementCancelTodoItem ($id: Int!, $cancel_reason: String) {
				${CANCEL_TODO_ITEM}
				}
				${fragments.TodoItemWithOutCommentsPagination}
			`,
				variables: {
					id: payload.id,
					cancel_reason: payload.cancel_reason || ""
				}
			})
			.then(response => response.data.cancel_todolist);
	},
	rejectTodoItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementRejectTodoItem ($id: Int!, $reject_reason: String) {
				${REJECT_TODO_ITEM}
				}
				${fragments.TodoItemWithOutCommentsPagination}
			`,
				variables: {
					id: payload.id,
					reject_reason: payload.reject_reason || ""
				}
			})
			.then(response => response.data.reject_todolist);
	},
	setStatusTodo(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListSetStatusTodoItem (
					$id: Int!,
					$status: Int!,
					$info: String
				) {
					${SET_STATUS_TODOLIST}
				}
				${fragments.TodoItemDetail}
			`,
				variables: {
					id: payload.id,
					status: payload.status,
					info: payload.info || ""
				}
			})
			.then(response => response.data.set_status_todolist);
	},
	toggleScheduleTodolist(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListToggleScheduleTodoItem (
					$id: Int!,
					$enable: Boolean!
				) {
					${TOGGLE_SCHEDULE_TODOLIST}
				}
				${fragments.TodoItemDetail}
			`,
				variables: {
					id: payload.id,
					enable: payload.enable
				}
			})
			.then(response => response.data.toggle_schedule_todolist);
	},
	fetchTodoByRelations(payload) {
		const queryOptions = {
			query: gql`query ListTodoListByRelations (
				$limit: Int!,
				$page: Int!,
				$orderBy: OrderByObject,
				$type: Int,
				$relations: [IdTypeInput],
				$statuses: [Int] ) {
					${GET_TODO_LIST_BY_RELATIONS}
				}
				${fragments.TodoItemLogsByRelations}
			`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1,
				orderBy: payload.orderBy || { column: "id", direction: "desc" },
				type: payload.type,
				statuses: payload.statuses || [],
				relations: payload.relations || []
			}
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => {
			return {
				todoList: response.data.todolists.data,
				totalTodoList: response.data.todolists.total
			};
		});
	},

	getTodoStatistic() {
		const queryOptions = {
			query: gql`query GetTodoStatistic {
					${GET_TODO_LIST_STATISTIC}
				}
				${fragments.TodoStatistic}
			`
		};
		return graphqlClient.query(queryOptions).then(response => response.data.todolist_statistic);
	},
	updateTodoItemWatcher(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementUpdateTodoItemWatcher (
						$id: Int!,
						$watchers: [TodolistWatcherInput],
						$name: String
					) {
						${UPDATE_TODO_ITEM_WATCHER}
					}
					${fragments.TodoItemDetail}

				`,
				variables: {
					id: payload.id,
					watchers: payload.watchers || [],
					name: payload.name
				}
			})
			.then(response => response.data.update_todolist);
	},

	updateMultipleTodoItem(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateMultipleTodoItem ($list: [TodolistInput]!) {
						${UPDATE_MULTIPLE_TODO_ITEM}
					}
					${fragments.TodoItemWithOutCommentsPagination}
				`,
				variables: {
					list: payload
				}
			})
			.then(response => response.data.update_multiple_todolist);
	},
	getTodolistCount(payload) {
		const queryOptions = {
			query: gql`query TodolistCount (
				$flag: Int) {
					${GET_TODO_LIST_COUNT}
				}
			`,
			variables: {
				flag: payload.flag || null
			}
		};
		return graphqlClient.query(queryOptions).then(response => response.data.todolist_count);
	},
	cloneTodolist(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation CloneTodolist ($id: Int!) {
						${CLONE_TODOLIST}
					}
					${fragments.TodoItemBasicPagination}
				`,
				variables: {
					id: payload.id
				}
			})
			.then(response => response.data.clone_todolist);
	},
	updateTodoItemAttachs(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation TodoListManagementUpdateTodoItemAttachs (
						$id: Int!,
						$attachs: [Int]
					) {
						${UPDATE_TODO_ITEM_ATTACHS}
					}
					${fragments.TodoItemDetailAttachs}

				`,
				variables: {
					id: payload.id,
					attachs: payload.attachs || []
				}
			})
			.then(response => response.data.update_attachs_todolist);
	}
};
